module.exports = __webpack_public_path__ + "media/images/partners/world-health-organisation-42225ab9b5bad19c0e0abadb49248dde.png";